import { BasePage as CngBasePage } from 'cng-web-lib'
import React from 'react'
import useBreadcrumbNameMap from 'src/navigations/breadcrumbs/Breadcrumb_SCOInvMgmt'
import DefaultLocConfigTranslationText from './DefaultLocConfigTranslationText'
import EditPage from './EditPage'


//* Module Title ---------------------------------------------------------------
function ModuleTitle() {
      const translatedTextsObject = DefaultLocConfigTranslationText();
      return translatedTextsObject.moduleTitle;
}

function WrappedEditPage(props) {
      const breadcrumbNameMap = useBreadcrumbNameMap()

      return (
            <CngBasePage
                  moduleTitle={ModuleTitle()}
                  renderPage={(showSnackbar) => (
                        <EditPage showNotification={showSnackbar} {...props} />
                  )}
                  extraCngBreadcrumbNameMap={breadcrumbNameMap}
            />
      )
}

export {
      WrappedEditPage as EditPage
}